import { produce } from 'immer';
import { getType } from 'typesafe-actions';

import { exportUrl } from '../api/CanvasUrlHelper';
import { batchesListReducer, initialBatchesListState } from '../BatchesList/reducers';
import { getCreativeSizes } from '../common/helpers';
import { Order, SharedData } from '../common/typings';

import * as actions from './actions';
import { CommonCreativesState } from './typings';

export function getInitialCommonCreativesState(sharedData?: SharedData) {
    return {
        batchesList: initialBatchesListState,
        filter: {
            creativeSizesDataProvider: sharedData ? getCreativeSizes(sharedData) : [],
            creativeSizes: sharedData ? getCreativeSizes(sharedData) : [],
            order: Order.DESC,
            exportUrl: sharedData ? exportUrl(sharedData) : '',
            isFilterEnabled: sharedData ? sharedData.areFiltersDisabled !== true : true
        },
        error: undefined,
        isBusy: false
    };
}

export function commonCreatives(
    state: CommonCreativesState = getInitialCommonCreativesState(),
    action: actions.CommonCreativesAction
): CommonCreativesState {
    return produce(state, draft => {
        switch (action.type) {
            case getType(actions.loadItems):
                draft.isBusy = true;
                draft.filter.order = action.order;
                batchesListReducer(draft.batchesList, action);

                return;

            case getType(actions.hideError):
                draft.error = undefined;

                return;

            case getType(actions.showError):
                draft.isBusy = false;
                draft.error = { message: action.message };

                return;

            case getType(actions.loadItemsSuccess):
            case getType(actions.applySizesFilter):
                draft.isBusy = false;
                draft.filter.creativeSizes = action.sizes;
                batchesListReducer(draft.batchesList, action);

                return;

            case getType(actions.saveName):
            case getType(actions.deleteCreative): {
                draft.isBusy = true;
                batchesListReducer(draft.batchesList, action);

                return;
            }

            case getType(actions.deleteCreativeSuccess):
            case getType(actions.saveNameSuccess): {
                draft.isBusy = false;
                batchesListReducer(draft.batchesList, action);

                return;
            }

            case getType(actions.setSelection):
            case getType(actions.showDeleteConfirm):
            case getType(actions.hideDeleteConfirm):
            case getType(actions.showCreativesSelector):
            case getType(actions.hideCreativesSelector):
            case getType(actions.toggleSizesSelection):
            case getType(actions.submitSizesSelection): {
                batchesListReducer(draft.batchesList, action);

                return;
            }

            default:
                return;
        }
    });
}
